import React from "react";
import { CreditorCases } from "us.collection.creditor/components/CreditorCases";
import { withRouter } from "us.common/wIthRouter";
interface ICnt_EditCreditorInfo {
}

const Cnt_EditCreditorInfo: React.FC<ICnt_EditCreditorInfo> = (props) => {
  return <CreditorCases  {...props} />;
};

export default withRouter(Cnt_EditCreditorInfo);
